<template>
  <Comments
    v-bind="$attrs"
    v-on="$listeners"
    data-testid="fc-conversation"
  />
</template>

<script>
import Comments from './Comments.vue';

/** Promoted conversation widget — retains @-mention UX from Comments.vue. */
export default {
  name: 'FcConversation',
  components: { Comments },
  inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
@import './FcConversation.scss';
</style>
